/*
 * Copyright (c) 2023 SARL SIGMA POLYNESIA
 */

import { useCallback, useState } from 'react'
import { useIntl } from 'react-intl'
import DeleteSelectionModal, {
  DeleteSelectionModalProps
} from '../../../../client/js/components/modals/DeleteSelectionModal'

import { handleChangeEvent } from '../../../../client/js/lib/form'
import { parseBoolean } from '@jalik/form-parser'
import { Stack, Switch } from '@mantine/core'

export type DeleteInvoicesOptions = {
  deleteGeneratedTransactions: boolean,
  deleteManualTransactions: boolean,
  deletePaidTransactions: boolean
}

export type DeleteInvoicesModalProps = {
  onConfirm (value: number, options: DeleteInvoicesOptions): Promise<unknown>
} & DeleteSelectionModalProps<number>

function DeleteInvoicesModal (props: DeleteInvoicesModalProps) {
  const {
    opened,
    items,
    onConfirm,
    onSuccess,
    onClose
  } = props

  const intl = useIntl()

  // Items deletion.
  const [options, setOptions] = useState<DeleteInvoicesOptions>({
    deleteGeneratedTransactions: true,
    deleteManualTransactions: false,
    deletePaidTransactions: false
  })

  const handleOptionChange = useCallback((name: string, value: unknown) => {
    setOptions((s) => ({ ...s, [name]: value }))
  }, [])

  const handleConfirm = useCallback((value: number) => {
    return onConfirm(value, options)
  }, [onConfirm, options])

  return (
    <DeleteSelectionModal
      opened={opened}
      items={items}
      onClose={onClose}
      onConfirm={handleConfirm}
      onSuccess={onSuccess}
      requirePin
    >
      <Stack>
        <Switch
          checked={options.deleteGeneratedTransactions}
          disabled
          id="delete_generated_transactions_option"
          label={intl.formatMessage({
            id: 'delete_generated_transactions_linked_to_invoice',
            defaultMessage: 'Supprimer les dépenses et revenus créés automatiquement'
          })}
          name="deleteGeneratedTransactions"
          onChange={handleChangeEvent(
            handleOptionChange,
            { parser: parseBoolean }
          )}
          type="checkbox"
        />
        <Switch
          checked={options.deleteManualTransactions}
          id="delete_manual_transactions_option"
          label={intl.formatMessage({
            id: 'delete_manual_transactions_linked_to_invoice',
            defaultMessage: 'Supprimer les dépenses et revenus créés manuellement'
          })}
          name="deleteManualTransactions"
          onChange={handleChangeEvent(
            handleOptionChange,
            { parser: parseBoolean }
          )}
          type="checkbox"
        />
        <Switch
          checked={options.deletePaidTransactions}
          id="delete_paid_transactions_option"
          label={intl.formatMessage({
            id: 'delete_paid_transactions',
            defaultMessage: 'Supprimer les dépenses et revenus déjà payés'
          })}
          name="deletePaidTransactions"
          onChange={handleChangeEvent(
            handleOptionChange,
            { parser: parseBoolean }
          )}
          type="checkbox"
        />
      </Stack>
    </DeleteSelectionModal>
  )
}

export default DeleteInvoicesModal
